import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { IconChevronRight } from '@travel-frontend/icons';
import { Container } from '../../components/Menu/components/Container.js';
import { MenuItem } from '../../components/Menu/components/MenuItem/index.js';
import { SubItems } from '../../components/Menu/components/SubItems.js';
import { Link } from '../../primitives/index.js';
export const Menu = ({
  config,
  align = 'left',
  stretchTexts = true
}) => {
  return _jsx(Container, {
    children: config.map(({
      caption,
      link,
      items,
      footerLink
    }, index) => _jsxs(MenuItem, {
      label: caption,
      id: "main",
      link: link,
      align: align,
      stretchTexts: stretchTexts,
      children: [items && _jsx(SubItems, {
        items: items
      }), footerLink && _jsxs(Link, {
        href: footerLink.path,
        children: [footerLink.caption, _jsx(IconChevronRight, {})]
      })]
    }, index))
  });
};